import Head from "next/head";

type SEOProps = {
  seoData?: {
    page_title?: string;
    page_description?: string;
    page_canonical_url?: string;
    keywords?: string;
  };
  isIndex?: boolean;
};

const SEOHead: React.FC<SEOProps> = ({ seoData, isIndex = true }) => {
  if (!seoData) return null;

  const { page_title, page_description, page_canonical_url, keywords } =
    seoData;

  return (
    <Head>
      {page_title && <title>{page_title}</title>}
      {page_description && (
        <meta name="description" content={page_description} />
      )}
      {page_canonical_url && <link rel="canonical" href={page_canonical_url} />}
      <meta
        name="robots"
        content={isIndex ? "index,follow" : "noindex,nofollow"}
      />
      {keywords && <meta name="keywords" content={keywords} />}
    </Head>
  );
};

export default SEOHead;
